(function () {
  if (customElements.get('ce-cart') !== undefined) {
    return;
  }

  class Cart extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];
      this.selectors = {
        root: 'ce-cart',
        itemCount: '[data-cart-item-count]',
        freeShippingProgressBar: '[data-cart-free-shipping-progress-bar]',
        freeShippingMessage: '[data-cart-free-shipping-message]',
        scrollContainer: '[data-cart-scroll-container]',
        emptyLink: '[data-cart-empty-link]',
        lineItemTitle: '[data-cart-line-item-title]',
        toaster: 'ce-toaster',
      };

      this.abortController = null;
      this.scrollContainerScrollTop = null;
      this.previousActiveElementId = null;

      // Mudamos o nome para refletir que agora ele apenas dispara a busca
      this.handleCartRefresh = this.handleCartRefresh.bind(this);
    }

    get isLoading() {
      return this.getAttribute('is-loading');
    }

    set isLoading(value) {
      this.setAttribute('is-loading', value);
    }

    static get observedAttributes() {
      return ['is-loading'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }
      
      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }
      
      switch (name) {
        case 'is-loading':
          if (newValue !== null) {
            if (newValue === 'true') {
              const scrollContainer = this.querySelector(this.selectors.scrollContainer);
              if (scrollContainer !== null) {
                this.scrollContainerScrollTop = scrollContainer.scrollTop;
              }

              this.previousActiveElementId = document.activeElement.id;
              document.activeElement.blur();
            } else {
              if (this.scrollContainerScrollTop !== null) {
                this.querySelector(this.selectors.scrollContainer)?.scrollTo(0, this.scrollContainerScrollTop);
                this.scrollContainerScrollTop = null;
              }

              if (this.previousActiveElementId !== null) {
                const previousActiveElementSelector = `#${this.previousActiveElementId.replace(':', '\\:')}`;

                try {
                  const elementToFocus = this.querySelector(previousActiveElementSelector) || this.querySelector(this.selectors.lineItemTitle) || this.querySelector(this.selectors.emptyLink);
                  elementToFocus.focus({ preventScroll: true });
                } catch (error) {
                  if (error instanceof DOMException) {
                    // Fail silently.
                  }
                }
              }
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        itemCount: document.querySelector(this.selectors.itemCount),
        freeShippingProgressBar: document.querySelector(this.selectors.freeShippingProgressBar),
        freeShippingMessage: document.querySelector(this.selectors.freeShippingMessage),
        toaster: document.querySelector(this.selectors.toaster),
      };

      // *** CORREÇÃO: Escuta o evento que o botão dispara e chama this.get() ***
      document.addEventListener('Themu:cart:add', this.handleCartRefresh); 
      
      this.get();

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      // *** REMOVE O LISTENER ***
      document.removeEventListener('Themu:cart:add', this.handleCartRefresh);
    }

    // Função que busca o HTML do carrinho atualizado do servidor
    async get() {
      this.isLoading = true;

      try {
        const sections = encodeURIComponent(`cart-data,${this.getAttribute('section-id')},cart-drawer-notification`);
        const resource = `${Shopify.routes.root}?sections=${sections}`;
        const response = await fetch(resource);
        const responseBody = await response.json();
        // O update agora recebe o HTML diretamente do /?sections=...
        this.update(responseBody['cart-data'], responseBody[this.getAttribute('section-id')], responseBody['cart-drawer-notification']);
      } catch (error) {
        // Fail silently.
      } finally {
        this.isLoading = false;
      }
    }

    async change(key, quantity) {
      // *** ESTE CÓDIGO É RESPONSÁVEL PELA REMOÇÃO (Funciona com update) ***
      if (this.abortController !== null) {
        this.abortController.abort();
        this.abortController = null;
      }

      this.isLoading = true;

      try {
        this.abortController = new AbortController();

        const requestBody = JSON.stringify({
          id: key,
          quantity: parseInt(quantity),
          sections: ['cart-data', this.getAttribute('section-id'), 'cart-drawer-notification'],
        });

        const response = await fetch(Themu.routes.cartChange, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: requestBody,
          signal: this.abortController.signal,
        });

        if (!response.ok) {
          throw Error;
        }

        const responseBody = await response.json();

        // Remoção usa o update
        this.update(responseBody.sections['cart-data'], responseBody.sections[this.getAttribute('section-id')], responseBody.sections['cart-drawer-notification']);

        this.elements.toaster.makeToast('success', Themu.t.cart.messages.update_success);

        const updatedItem = responseBody.items.find((item) => item.key === key);
        if (updatedItem !== undefined && updatedItem.quantity < quantity) {
          this.elements.toaster.makeToast('warning', Themu.t.cart.messages.update_warning, 10000);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.elements.toaster.makeToast('danger', Themu.t.cart.messages.update_error);
        }
      } finally {
        this.isLoading = false;
      }
    }

    // *** FUNÇÃO UPDATE (Injeta HTML e Atualiza Contador) ***
    update(cartDataHtml, cartHtml, notificationHtml) {
      const notification = document.querySelector('#cart-drawer-notification');

      // 1. ATUALIZA NOTIFICAÇÃO
      if (notification !== null) {
        const html = new DOMParser().parseFromString(notificationHtml, 'text/html');
        notification.innerHTML = html.querySelector('.shopify-section').innerHTML;
      }

      // 2. ATUALIZA CONTEÚDO PRINCIPAL (Injeção de HTML, que não funciona para itens, mas é necessária para a estrutura)
      let cartHtmlDoc = new DOMParser().parseFromString(cartHtml, 'text/html');
      
      const updatedCartContent = cartHtmlDoc.querySelector('ce-cart');
      
      if (updatedCartContent) {
        this.innerHTML = updatedCartContent.innerHTML;
      } else {
        const sectionId = this.getAttribute('section-id');
        const newSectionContent = cartHtmlDoc.querySelector(`#shopify-section-${sectionId}`);

        if (newSectionContent) {
           const fallbackCart = newSectionContent.querySelector('ce-cart');
           if (fallbackCart) {
              this.innerHTML = fallbackCart.innerHTML;
           } else {
              this.innerHTML = newSectionContent.innerHTML;
           }
        } else {
            console.error('Falha crítica: Não foi possível encontrar o conteúdo do carrinho para atualização.');
        }
      }
      
      // 3. ATUALIZA DADOS DO CONTADOR E FRETE (PONTO DE SUCESSO)
      let cartDataDoc = new DOMParser().parseFromString(cartDataHtml, 'text/html');

      // ESTA LINHA É CRUCIAL PARA O ÍCONE
      this.elements.itemCount.textContent = cartDataDoc.querySelector('[data-item-count]').textContent;

      if (Themu.settings.useFreeShippingThreshold) {
        this.elements.freeShippingProgressBar.style.setProperty('--current', cartDataDoc.querySelector('[data-total-price]').textContent);
        this.elements.freeShippingMessage.textContent = cartDataDoc.querySelector('[data-free-shipping-message]').textContent;
      }
    }

    // *** MÉTODO DE REFRESH FORÇADO ***
    handleCartRefresh() {
      // Quando o evento de adição chega, em vez de usar os dados do payload,
      // ele força uma nova requisição GET completa.
      this.get();
    }
  }

  customElements.define('ce-cart', Cart);
})();